import { ClientItem, mailStore } from 'owa-mail-store';
import { mutator } from 'satcheljs';
import storeAttachmentSuggestionsOnItemAction from '../actions/storeAttachmentSuggestionsOnItemAction';

export default mutator(storeAttachmentSuggestionsOnItemAction, actionMessage => {
    const referenceItem: ClientItem = mailStore.items.get(actionMessage.referenceItemId);

    if (referenceItem) {
        referenceItem.AttachmentSuggestions = actionMessage.attachmentSuggestions;
    }
});
